import React from "react"

const SearchMobile = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M16.826 15.8833L12.8467 11.904C13.9311 10.5777 14.4643 8.8854 14.3359 7.17705C14.2075 5.46869 13.4275 3.87503 12.1571 2.72569C10.8866 1.57635 9.22307 0.959267 7.51043 1.00209C5.7978 1.04491 4.16714 1.74435 2.95575 2.95575C1.74435 4.16714 1.04491 5.7978 1.00209 7.51043C0.959267 9.22307 1.57635 10.8866 2.72569 12.1571C3.87503 13.4275 5.46869 14.2075 7.17705 14.3359C8.8854 14.4643 10.5777 13.9311 11.904 12.8467L15.8833 16.826C16.0091 16.9474 16.1775 17.0146 16.3523 17.0131C16.5271 17.0116 16.6943 16.9415 16.8179 16.8179C16.9415 16.6943 17.0116 16.5271 17.0131 16.3523C17.0146 16.1775 16.9474 16.0091 16.826 15.8833ZM7.68801 13.0213C6.63317 13.0213 5.60203 12.7085 4.72496 12.1225C3.8479 11.5365 3.16432 10.7035 2.76065 9.72898C2.35698 8.75444 2.25136 7.68209 2.45715 6.64752C2.66294 5.61296 3.17089 4.66265 3.91677 3.91677C4.66265 3.17089 5.61296 2.66294 6.64752 2.45715C7.68209 2.25136 8.75444 2.35698 9.72898 2.76065C10.7035 3.16432 11.5365 3.8479 12.1225 4.72496C12.7085 5.60203 13.0213 6.63317 13.0213 7.68801C13.0198 9.10201 12.4573 10.4576 11.4575 11.4575C10.4576 12.4573 9.10201 13.0198 7.68801 13.0213Z"
        fill="#2B4346"
        stroke="#2B4346"
        strokeWidth="0.25"
      />
    </svg>
  )
}

export default SearchMobile
